import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const PERMS = [["invoices:read", "Vede Fatture emesse"], ["supplier_invoices:read", "Vede Fatture fornitori"], ["supplier_invoices:manage", "Abbina fatture fornitori agli ordini"]];
const val = (u, p) => (u.perm_grant.includes(p) ? "yes" : u.perm_deny.includes(p) ? "no" : "role");

export const UserAccessAction = ({ user, rolePerms, onDone }) => {
  const [open, setOpen] = useState(false);
  const [v, setV] = useState({});
  const [busy, setBusy] = useState(false);
  const custom = user.perm_grant.length + user.perm_deny.length;
  const start = () => { setV(Object.fromEntries(PERMS.map(([p]) => [p, val(user, p)]))); setOpen(true); };
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/admin/users/${user.id}/access`, { grant: PERMS.map(([p]) => p).filter((p) => v[p] === "yes"), deny: PERMS.map(([p]) => p).filter((p) => v[p] === "no") });
      toast.success("Accesso fatture aggiornato"); setOpen(false); onDone();
    } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size="sm" variant="ghost" className="gap-1 text-xs" onClick={start} data-testid={`user-access-${user.id}`}><KeyRound className="h-3.5 w-3.5" />Fatture{custom ? " ·" : ""}{custom ? <span className="font-semibold text-brand-700">personalizzato</span> : ""}</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="user-access-dialog">
          <DialogHeader><DialogTitle>Accesso fatture · {`${user.first_name} ${user.last_name}`.trim() || user.email}</DialogTitle>
            <DialogDescription>«Come il ruolo» segue le impostazioni della pagina Ruoli. «Sì» e «No» valgono solo per questa persona.</DialogDescription></DialogHeader>
          <div className="space-y-3">{PERMS.map(([p, l]) => (
            <div key={p} className="flex items-center justify-between gap-3">
              <span className="text-sm text-ink">{l}<span className="block text-xs text-slate-500">Ruolo {user.role_name}: {rolePerms.includes(p) ? "sì" : "no"}</span></span>
              <Select value={v[p]} onValueChange={(x) => setV({ ...v, [p]: x })}>
                <SelectTrigger className="h-8 w-40 text-sm" data-testid={`user-access-${p}`}><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="role">Come il ruolo</SelectItem><SelectItem value="yes">Sì</SelectItem><SelectItem value="no">No</SelectItem></SelectContent>
              </Select>
            </div>))}</div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button><Button disabled={busy} onClick={save} data-testid="user-access-save">Salva</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
